var _style, _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinMap1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000108302837110008831780000013279194766466071468_);}\r\n\t.st1{fill:#121212;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078003267250789085370000012750724485766767538_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078003267250789085370000012750724485766767538_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,15.5c-0.2,0-0.5-0.1-0.7-0.3c-0.6-0.5-5.6-5.3-5.6-8.7c0-1.7,0.6-3.3,1.7-4.6c1.2-1.2,2.8-2,4.5-2 c1.8,0.1,3.4,0.8,4.5,2c1.2,1.2,1.8,2.9,1.7,4.6c0,3.4-5,8.1-5.6,8.7C12.5,15.4,12.2,15.5,12,15.5z M12,2c-1.1,0-2.2,0.5-3,1.4 s-1.2,2-1.2,3.2c0,1.7,2.4,4.7,4.3,6.6c1.9-1.9,4.2-4.8,4.2-6.5c0,0,0,0,0,0c0-1.2-0.4-2.3-1.2-3.2C14.3,2.5,13.1,2,12,2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.5,23.2c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4v-15c0-0.5,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6 h1.3c0.6,0,1,0.4,1,1s-0.4,1-1,1H2.5l0,15l19,0l0-15l-1.2,0c-0.6,0-1-0.4-1-1s0.4-1,1-1h1.3c0.5,0,1,0.2,1.4,0.6 c0.4,0.4,0.6,0.9,0.6,1.4v15c0,0.5-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6H2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMap1);
export default __webpack_public_path__ + "static/media/pin-map 1.c66ea8e060c962da9b63b55970a77f3a.svg";
export { ForwardRef as ReactComponent };